module.exports = __webpack_public_path__ + "static/img/eisbecher-gelb.a14a757.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisbecher-gelb.jpg
// module id = x6qS
// module chunks = 0